module.exports = __webpack_public_path__ + "assets/img/9030fba609f33406f553b4c7c69a09ab.svg";